import { gql } from '@apollo/client'
import CompanyFragment from './Company.fragment'
// This is the same for public and resigned public profiles
export default gql`
  fragment BusinessUnitAndComapnyName on BusinessUnit {
    name
    company {
      ...CompanyName
    }
  }
  ${CompanyFragment}
`
